import { render } from "./AccountManageHeader.vue?vue&type=template&id=49f62821&scoped=true&ts=true"
import script from "./AccountManageHeader.vue?vue&type=script&lang=ts"
export * from "./AccountManageHeader.vue?vue&type=script&lang=ts"

import "./AccountManageHeader.vue?vue&type=style&index=0&id=49f62821&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f62821"]])